import type { ReactNode } from 'react';
import { IconWrapper, Wrapper } from './IconTextPair.styles';

export interface IconTextPairProps {
  icon: ReactNode;
  text: ReactNode;
  gap?: number;
}

export function IconTextPair({ icon, text, gap = 2 }: IconTextPairProps) {
  return (
    <Wrapper $gap={gap}>
      <IconWrapper>{icon}</IconWrapper>
      <span>{text}</span>
    </Wrapper>
  );
}
